import { AlertActionTypes, TAlertState } from '../types/alert.types';

export const openAlert = (key: keyof TAlertState) => ({
  type: AlertActionTypes.OPEN_ALERT,
  key,
});

export const closeAlert = (key: keyof TAlertState) => ({
  type: AlertActionTypes.CLOSE_ALERT,
  key,
});

export const validateAction = (key: keyof TAlertState) => ({
  type: AlertActionTypes.VALIDATE_ACTION,
  key,
});
